import { themeQuartz } from 'ag-grid-community'

export const gridTheme = themeQuartz.withParams({
   headerFontFamily: 'Funnel Display',
   cellFontFamily: 'Funnel Sans',
   accentColor: 'var(--color-grey)',
   headerBackgroundColor: 'var(--color-light-grey)',
   textColor: 'var(--color-primary)',
   iconColor: 'var(--color-primary)',
   wrapperBorderRadius: 'var(--radius-small)',
   spacing: 7,
})
